import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

/* HOC used to inject a boolean prop used to determine if the current language is RTL.
 * If it is RTL, It also wraps the component with a div that has the supplied styles applied.
 */
export const withRtl = (...styles) => Component => {
  const WithRtl = props =>
    props.isRtl ? (
      <div className={classNames(...styles.filter(style => style.rtl).map(style => style.rtl))}>
        <Component {...props} />
      </div>
    ) : (
      <Component {...props} />
    );

  WithRtl.propTypes = {
    isRtl: PropTypes.bool.isRequired,
  };

  const mapStateToProps = ({ intl }) => ({ isRtl: intl.langDir === 'rtl' });

  return connect(mapStateToProps)(WithRtl);
};

/* HOC used to inject the rtl css classes and a boolean prop used to determine if the current language is RTL.
 * Unlinke withRtl, it doesn't wrap the component into a div, but rather passes the css classes as a prop.
 */
export const injectRtl = (...styles) => Component => {
  const InjectRtl = props =>
    props.isRtl ? (
      <Component rtlClasses={classNames(...styles.filter(style => style.rtl).map(style => style.rtl))} {...props} />
    ) : (
      <Component {...props} />
    );

  InjectRtl.propTypes = {
    isRtl: PropTypes.bool.isRequired,
  };

  const mapStateToProps = ({ intl }) => ({ isRtl: intl.langDir === 'rtl' });

  return connect(mapStateToProps)(InjectRtl);
};

export default withRtl;
